module.exports = __webpack_public_path__ + "ac327c4db6284ef64ebe872b6308f5da.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Regular/OpenSans-Regular.woff?v=1.1.0
// module id = 984
// module chunks = 0